import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AccountRights, BaseAccount } from '@shared/models';
import { UserDetailsFeatureName, UserDetailsState } from '.';

export const getUserDetailsState = createFeatureSelector<UserDetailsState>(
  UserDetailsFeatureName
);

const getUserDetails = createSelector(
  getUserDetailsState,
  (state) => state.data
);

const getTermsConditionsAccepted = createSelector(
  getUserDetailsState,
  (state) => state.data.termsConditionsAccepted
);

const getSubprojects = createSelector(
  getUserDetailsState,
  (state) => state.data?.subprojects
);

const getSelectedSubprojectId = createSelector(
  getUserDetailsState,
  (state) => state.data?.selectedSubprojectId
);

const getSelectedSubproject = createSelector(
  getUserDetailsState,
  (state) => state.data?.selectedSubproject
);

const getProjectSetup = createSelector(
  getSelectedSubproject,
  (substate) => substate?.data
);

const getSubprojectConfiguration = createSelector(
  getProjectSetup,
  (substate) => substate.subprojectConfiguration
);

const getCustomTabNames = createSelector(
  getSubprojectConfiguration,
  (substate) => substate.customNames
);

const getClients = createSelector(
  getUserDetailsState,
  (state) => state.data?.clientsList
);

const getSelectedClientId = createSelector(
  getUserDetailsState,
  (state) => state.data?.selectedClientId
);

const getSelectedClient = createSelector(
  getUserDetailsState,
  getSelectedClientId,
  (state, selectedClientId) =>
    state.data?.clientsList.find((x) => x.id === selectedClientId)
);

const getModules = createSelector(
  getUserDetailsState,
  (state) => state.data?.modules
);

const getAccountId = createSelector(
  getUserDetailsState,
  (state) => state.data?.accountId
);

const getBaseAccount = createSelector(getUserDetailsState, (state) => {
  return {
    id: state.data?.accountId,
    firstName: state.data?.firstName,
    lastName: state.data?.lastName,
    accountType: state.data?.accountType,
    email: state.data?.email,
  } as BaseAccount;
});

const getAccountType = createSelector(
  getUserDetailsState,
  (state) => state.data?.accountType
);

const getAccountRights = createSelector(getUserDetailsState, (state) => {
  return {
    settingsRight: state.data?.settingsRight,
    userAdminRight: state.data?.userAdminRight,
  } as AccountRights;
});

const getColorTypes = createSelector(
  getUserDetailsState,
  (state) => state.data?.colorTypes
);

const getCustomDataOperators = createSelector(
  getUserDetailsState,
  (state) => state.data?.customDataOperators
);

export const userDetailsQuery = {
  getUserDetails,
  getTermsConditionsAccepted,
  getSubprojects,
  getSelectedSubprojectId,
  getSelectedSubproject,
  getProjectSetup,
  getSubprojectConfiguration,
  getCustomTabNames,
  getSelectedClientId,
  getClients,
  getSelectedClient,
  getModules,
  getAccountId,
  getBaseAccount,
  getAccountType,
  getAccountRights,
  getColorTypes,
  getCustomDataOperators,
};
